import { render, staticRenderFns } from "./DeliveryStepHeadToShipper.vue?vue&type=template&id=595785c3&scoped=true&"
import script from "./DeliveryStepHeadToShipper.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepHeadToShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595785c3",
  null
  
)

export default component.exports